module.exports = __webpack_public_path__ + "static/media/66960033-t7C0wSgs.d5c394ee.JPG";